
const fitCodeEvents = {
  FETCH_FITCODE_DATA_PROGRESS: 'fitcode/fetch_data_progress',
  FETCH_FITCODE_DATA_SUCCESS: 'fitcode/fetch_data_success',
  FETCH_FITCODE_DATA_FAILED: 'fitcode/fetch_data_failed',
};

export default fitCodeEvents;
